import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Pain } from './components/Pain';
import { Method } from './components/Method';
import { Mastery } from './components/Mastery';
import { Gallery } from './components/Gallery';
import { ValueStack } from './components/ValueStack';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="31agoaol7qfjg">
      <Hero data-id="element-1" data-mp="31c1ha9rvpqf7" />
      <main data-id="element-2" data-mp="31ctbbg5tvg3d">
        <Hook data-id="element-3" data-mp="2wk09b01quluz" />
        <Pain data-id="element-4" data-mp="2wjgqlh49rtfw" />
        <Method data-id="element-5" data-mp="2wjqff1dkvuk0" />
        <Mastery data-id="element-6" data-mp="2wj8f9tnsow6t" />
        <Gallery data-id="element-7" data-mp="2wip734ny5m5z" />
        <ValueStack data-id="element-8" data-mp="2wi5mfg6wwjo9" />
        <Pricing data-id="element-9" data-mp="28u5vaf5our95" />
        <Faq data-id="element-10" data-mp="28tmifcuwat1z" />
        <Guarantee data-id="element-11" data-mp="28t4l0cwhy8sh" />
      </main>
      <Footer data-id="element-12" data-mp="28sbe9bxjfjac" />
      <StickyCta data-id="element-13" data-mp="23vci6nubd29i" />
    </div>;
}